import React from 'react';
import { Col, Row } from '@vertem-core/vertice-ds'
import PropTypes from 'prop-types';
import StaticBannersService from './components/StaticBannersService';
import CarouselBannersService from './components/CarouselBannersService';

const ServicesBannersForHome = ({
  children,
  banners,
}) => {
  return (
    <section className="ServicesBannersForHome">
      <Row>
        <Col sm={24}>
          <div
            className={(banners.length < 4) ? 'ServicesBannersForHome-Container' : 'ServicesBannersForHome-row'}
          >
            {(() => {
              if (children) {
                return (children);
              }
              return (banners.length < 4) ? <StaticBannersService banners={banners} />
                : <CarouselBannersService banners={banners} />;
            })()}
          </div>
        </Col>
      </Row>
    </section>
  );
};


ServicesBannersForHome.propTypes = {
  banners: PropTypes.array,
  children: React.Children,
};

export default ServicesBannersForHome;
